export enum ToggleTheme {
	default,
	squareL,
	squareM,
}